export const userDropdown = {
  userProfile: 'Mein Konto',
  userData: 'Persönliche Daten',
  userOrders: 'Meine Online-Bestellungen',
  userAddress: 'Meine Adressen',
  logOut: 'Abmelden',
  logIn: 'Anmelden',
};

const megaCard = {
  choice: {
    reject: 'Ich möchte jetzt keine MegaCard',
    rejectDetail:
      'Falls Sie Ihre Meinung ändern, können Sie in Ihrem Profil eine MegaCard bestellen oder verbinden.',
    want: 'Ich möchte eine MegaCard',
    wantDetail: 'Wir senden Ihnen eine MegaCard an die unten angegebene Postadresse zu.',
    have: 'Ich habe eine Megacard',
    haveDetail: 'Wenn Sie Ihre MegaCard mit dem Shop verbinden, werden Ihre persönlichen Daten automatisch ' +
      'übernommen. Sie können diese selbstverständlich noch anpassen.',
  },
  title: 'Meine MegaCard',
  number: 'MegaCard-Nummer',
  postCode: 'Ihre PLZ',
  pleaseChoose: 'Bitte wählen Sie:',
  noChoice: 'Bitte wählen Sie oben, ob Sie eine MegaCard haben.',
  actionConnect: 'Prüfen',
  actionDisconnect: 'Rückgängig',
  register: {
    connectSuccess: 'Vielen Dank, {successName}. Ihre MegaCard wurde erfolgreich verbunden und Ihre ' +
      'persönlichen Daten unten übernommen.',
    connectUnknown: 'Zu diesen Daten konnten wir leider keine Megacard finden. Sie können Ihre Megacard auch ' +
      'noch später im Profil hinzufügen.',
    connectError: 'Es ist ein Fehler bei der Abfrage aufgetreten. Sie können Ihre Megacard auch ' +
      'noch später im Profil hinzufügen.',
  },
  profile: {
    connectSuccess: 'Vielen Dank, {successName}. Bitte bestätigen Sie die Verbindung durch Klick auf ' +
      '"Speichern". Beachten Sie, dass die MegaCard-Verknüpfung danach nicht mehr geändert werden kann.',
    connectUnknown: 'Zu diesen Daten konnten wir leider keine Megacard finden. Bei Fragen können Sie uns gerne ' +
      'anrufen.',
    connectError: 'Es ist ein Fehler bei der Abfrage aufgetreten. Bitte versuchen Sie es später erneut.',
    connectHint: 'Um Ihre MegaCard zu verknüpfen, geben Sie hier Ihre MegaCard-Nummer ein. Sie finden diese ' +
      'auf der Vorderseite der Karte unter dem Strichcode. Zur Verifikation geben Sie bitte zusätzlich Ihre ' +
      'Postleitzahl ein.',
    hasInfo: 'Ihr Konto ist mit der MegaCard {number} (PLZ: {postCode}) verbunden.',
    teaser: 'Haben Sie gewusst, dass Sie mit {infoLink} bei jedem Einkauf profitieren können?',
    infoLink: 'unserer Kundenkarte MegaCard',
    actionOrder: 'MegaCard bestellen',
    actionConnect: 'MegaCard verknüpfen',
  },
};

export const userData = {
  register: 'Registrierung',
  registerHeader: {
    step1: 'Konto anlegen',
    step2: 'Daten ergänzen',
    step3: 'Bestätigung',
  },
  registerDescription: 'Geben Sie jetzt Ihren Namen und Ihre Kontaktdaten bekannt. Sie können diese später unter "Mein Konto" abändern.',
  registerConfirmationFallback: 'Ihre Registrierung war erfolgreich. Entdecken Sie nun die Vielfalt des Sortiments bei DER GRISSEMANN!',
  registerNoUser: 'Serverfehler, bitte versuchen Sie es später erneut.',
  personalData: 'Persönliche Daten',
  changePassword: 'Passwort ändern',
  edit: 'Persönliche Daten ändern',
  shoppingCart: 'Warenkorb',
  salutation: 'Anrede',
  salutationValue: {
    mr: 'Herr',
    mrs: 'Frau',
  },
  order: {
    orderWithNr: 'Bestellung {orderId}',
    orderDate: 'am {date}',
    orderValue: 'Bestellwert',
    back: 'Zurück zu meinen Bestellungen',
  },
  firstName: 'Vorname',
  lastName: 'Nachname',
  email: 'E-Mail',
  birthDate: 'Geburtsdatum',
  company: 'Firma',
  address: 'Adresse',
  pageSize: 'Produkte pro Seite',
  addressData: {
    title: 'Ihre Adressen',
    countryCode: 'Staat',
    postCode: 'PLZ',
    city: 'Ort',
    street: 'Straße',
    streetNr: 'Nr.',
    company: 'Firma',
    empty: 'Mit Ihrem Account sind aktuell keine Adressen verknüpft.',
    telephone: 'Telefon',
    email: 'E-Mail-Adresse',
    birthday: 'Geburtsdatum',
  },
  megaCard,
  standardBilling: 'Standard-Rechnungsadresse',
  standardDelivery: 'Standard-Lieferadresse',
  setStandardBilling: 'Als Standard-Rechnungsadresse verwenden',
  setStandardDelivery: 'Als Standard-Lieferadresse verwenden',
};

export const lists = {
  brand: {
    singular: 'Einkaufsliste',
    plural: 'Einkaufslisten',
  },
  myLists: {
    title: 'Meine Einkaufslisten',
    addNew: 'Neue Liste anlegen',
    addAllToCart: 'Gesamte Liste in den Warenkorb',
    empty: 'Sie haben noch keine Artikel auf Ihrer Einkaufsliste.',
    delete: 'Einkaufsliste löschen',
    deleteWarning: 'Ihre Einkaufsliste wird unwiderruflich gelöscht.',
    noLists: 'Sie haben noch keine Einkaufsliste erstellt.',
    cartItems: 'derzeit im Warenkorb',
  },
  popup: {
    edit: 'Einkaufslisten bearbeiten',
    addTo: 'zu folgenden Einkaufslisten hinzufügen',
    addNew: 'Neue Liste erstellen',
    openPopup: 'Auf die Einkaufsliste',
  },
};

export const cart = {
  resumeShopping: 'Einkauf fortsetzen',
  emptyCart: 'Warenkorb leeren',
  emptyCartWarning: 'Ihre bisherigen Artikel im Warenkorb werden unwiderruflich gelöscht.',
  yourCart: 'Ihr Warenkorb',
  products: 'Artikel',
  cartIsEmpty: 'Sie haben nichts im Warenkorb.',
  otherCategory: 'Sonstige',
  labels: {
    product: 'Artikel',
    singlePrice: 'Einzelpreis',
    positionPrice: 'Gesamtpreis',
    amount: 'Menge',
  },
  checkout: {
    address: {
      billing: 'Rechnungsadresse',
      delivery: 'Lieferadresse',
      deliverySeparate: 'Abweichende Lieferadresse',
    },
  },
  summary: {
    value: 'Warenwert',
    totalPriceWithTax: 'Gesamtsumme (inkl. Mwst)',
    checkout: 'Zur Kassa gehen',
    itemsValue: 'Warenwert',
    shippingFees: 'Liefergebühr / Servicegebühr',
    plus: 'zzgl.',
    deposit: 'Pfand',
    discount: 'Aktions-Ersparnis',
    noShippingFee: 'Nicht ausgewählt',
    minValueReached: 'Mindestbestellwert von {minValue} € erreicht',
    minValueNotReached: 'Noch {difference} € bis zum Mindestbestellwert von {minValue} €',
    coupon: 'Gutschein',
    couponRedeem: 'Gutschein einlösen',
    couponError: 'Gutschein ungültig',
  },
  add: 'In den Warenkorb',
  remove: 'Entfernen',
};
